import { FormattedMessage } from 'react-intl'
import { CardMedia, Box, styled } from '@mui/material'
import { Button } from '@carto/meridian-ds/components'
import CardBase from 'features/common/ui/Cards/CardBase/CardBase'
import { AddCircleOutlineOutlined } from '@mui/icons-material'
import EmptyWorkflowIcon from 'assets/icons/workflows/empty_workflow.svg?react'
import { WorkflowEmptyCardProps } from 'features/workflows/types'
import useUserRoles from 'features/account/state/useUserRoles'

const Overlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'transparent',
  border: `solid ${theme.spacing(0.25)} transparent`,
  overflow: 'hidden',
  borderRadius: theme.spacing(1),
  transition: theme.transitions.create('border', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.standard
  }),
  '&:hover': {
    backgroundColor: theme.palette.white[25],
    cursor: 'pointer',
    border: `solid ${theme.spacing(0.25)} ${theme.palette.primary.main}`,
    '& > div': {
      display: 'flex'
    }
  },
  '& > div': {
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    fontSize: theme.spacing(1.5),
    color: theme.palette.primary.main,
    height: '100%',
    borderRadius: theme.spacing(1),
    border: `solid ${theme.spacing(0.75)} ${theme.palette.divider}`,
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard
    })
  }
}))

const CenteredElementWrapper = styled(Box)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate3d(-50%,-50%,0)',
  textAlign: 'center',
  '& > button': {
    lineBreak: 'anywhere',
    whiteSpace: 'nowrap'
  }
}))

const CardBaseContainer = styled(CardBase)(() => ({
  position: 'relative'
}))

function WorkflowEmptyCard({ card, withButton }: { card: WorkflowEmptyCardProps; withButton?: boolean }) {
  const EmptyWorkflowOverlay = () => {
    return (
      <Overlay>
        <Box>
          <AddCircleOutlineOutlined />
          <FormattedMessage id="home.actions.workflow.new" />
        </Box>
      </Overlay>
    )
  }

  const { userHasEditionRole } = useUserRoles()

  const EmptyWorkflowButton = () => {
    return (
      <CenteredElementWrapper>
        <Button color="primary" variant="contained">
          <FormattedMessage id="home.actions.workflow.new" />
        </Button>
      </CenteredElementWrapper>
    )
  }

  return (
    <CardBaseContainer onClick={userHasEditionRole ? card.onClick : undefined} aria-label={'empty-workflow-label'}>
      <CardMedia style={{ height: '100%' }} image={card.img} title="title" component="img" />
      {!withButton && (
        <CenteredElementWrapper>
          <EmptyWorkflowIcon />
        </CenteredElementWrapper>
      )}
      {userHasEditionRole && (withButton ? <EmptyWorkflowButton /> : <EmptyWorkflowOverlay />)}
    </CardBaseContainer>
  )
}

export default WorkflowEmptyCard
